//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[],[[["condition"],"AddMatchingBreakpoint",{},1,0],[["condition"],"AddDataBreakpoint",{},1,0],[["program","lineNumber"],"AddBreakpoint",{},2,0],[["program","lineNumber"],"ActivateBreakpoint",{},2,0],[["program","lineNumber"],"DeactivateBreakpoint",{},2,0],[["program","lineNumber"],"DeleteBreakpoint",{},2,0],[["breakpointsLength"],"GetBreakpoints",{R_:{breakpoints:"SIM.Breakpoint[]"}},0,0],[[],"DeactivateAllBreakpoints",{},0,0],[[],"ActivateAllBreakpoints",{},0,0],[[],"DeleteAllBreakpoints",{},0,0],[[],"GetExternalFileSource",{R_:{source:"SIM.NcProgramSource"}},0,0],[[],"GetSetupSource",{R_:{source:"SIM.NcProgramSource"}},0,0],[[],"GetPostprocessorSource",{R_:{source:"SIM.NcProgramSource"}},0,0]],[]];
SPLM.SIM.NcProgramManagerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.NcProgramManagerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;